import VerifyAddress from './verify-address'

export default VerifyAddress
